import uuid from 'uuid-random';

import { showCommonPopupAction as showCommonPopupActionOriginal } from 'js/components/common/popups/CommonPopup/actions';

export const showCommonPopupAction = ({ id = uuid(), ...other }) => showCommonPopupActionOriginal({ id, ...other });
